<template>
  <div>
    <span v-translate>
      Your referral list is empty. Start referring today!
    </span>
    <div class="file is-centered people">
      <referrals-people-icon></referrals-people-icon>
    </div>
  </div>
</template>

<script>

import ReferralsPeopleIcon from './ReferralsPeopleIcon.vue';
export default {
  components: {ReferralsPeopleIcon}
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.people svg {
  max-width: 100%;
  height: auto;
}

@media screen and (max-width: $tablet) {
  .people {
    margin: 20px auto;
    max-width: 225px;
    max-height: 143px;
  }
}

@media screen and (min-width: $tablet) {
  .people {
    margin: 49px auto;
  }
}
</style>
